var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5022 1.01353L1.38672 5.29987C0.628128 5.60456 0.632517 6.02774 1.24754 6.21645L4.10134 7.10669L10.7042 2.94072C11.0164 2.75076 11.3017 2.85295 11.0672 3.0611L5.71757 7.8891H5.71631L5.71757 7.88973L5.52071 10.8313C5.8091 10.8313 5.93637 10.699 6.09812 10.5429L7.48426 9.19501L10.3675 11.3247C10.8992 11.6175 11.281 11.467 11.4133 10.8326L13.306 1.91256C13.4997 1.13579 13.0094 0.784076 12.5022 1.01353Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.6205c0c0efaa746a704aa388c932d28f.svg";
export { ForwardRef as ReactComponent };